import { yandexMap, ymapMarker } from 'vue-yandex-maps'

export { yandexMap, ymapMarker };